// NOM-035 — Guía de Referencia II: Factores de Riesgo Psicosocial (16–50 trabajadores)
// 46 ítems, 4 categorías, 8 dominios
// Asignación de ítems según Tabla 3 del DOF 23/10/2018
// Orden de secciones corregido para coincidir con el cuestionario oficial

export const GUIA_II_PREGUNTAS = [
  // ── Categoría: Ambiente de trabajo ──────────────────────
  // Ítems 1-3
  {
    dominio: "Condiciones en el ambiente de trabajo",
    categoria: "Ambiente de trabajo",
    intro: "Para responder las preguntas siguientes considere las condiciones de su centro de trabajo, así como la cantidad y ritmo de trabajo.",
    preguntas: [
      { id: "g2_1", num: 1, texto: "Mi trabajo me exige hacer mucho esfuerzo físico" },
      { id: "g2_2", num: 2, texto: "Me preocupa sufrir un accidente en mi trabajo" },
      { id: "g2_3", num: 3, texto: "Considero que las actividades que realizo son peligrosas" },
    ]
  },
  // ── Categoría: Factores propios de la actividad ─────────
  // Dominio: Carga de trabajo — ítems 4-9 (continúa intro de ítems 1-3)
  {
    dominio: "Carga de trabajo",
    categoria: "Factores propios de la actividad",
    visualContinue: true,
    preguntas: [
      { id: "g2_4", num: 4, texto: "Por la cantidad de trabajo que tengo debo quedarme tiempo adicional a mi turno" },
      { id: "g2_5", num: 5, texto: "Por la cantidad de trabajo que tengo debo trabajar sin parar" },
      { id: "g2_6", num: 6, texto: "Considero que es necesario mantener un ritmo de trabajo acelerado" },
      { id: "g2_7", num: 7, texto: "Mi trabajo exige que esté muy concentrado" },
      { id: "g2_8", num: 8, texto: "Mi trabajo requiere que memorice mucha información" },
      { id: "g2_9", num: 9, texto: "Mi trabajo exige que atienda varios asuntos al mismo tiempo" },
    ]
  },
  // Dominio: Carga de trabajo — ítems 10-13
  {
    dominio: "Carga de trabajo",
    categoria: "Factores propios de la actividad",
    intro: "Las preguntas siguientes están relacionadas con las actividades que realiza en su trabajo y las responsabilidades que tiene.",
    preguntas: [
      { id: "g2_10", num: 10, texto: "En mi trabajo soy responsable de cosas de mucho valor" },
      { id: "g2_11", num: 11, texto: "Respondo ante mi jefe por los resultados de toda mi área de trabajo" },
      { id: "g2_12", num: 12, texto: "En mi trabajo me dan órdenes contradictorias" },
      { id: "g2_13", num: 13, texto: "Considero que en mi trabajo me piden hacer cosas innecesarias" },
    ]
  },
  // ── Categoría: Organización del tiempo de trabajo ───────
  // Dominio: Jornada de trabajo — ítems 14-15
  {
    dominio: "Jornada de trabajo",
    categoria: "Organización del tiempo de trabajo",
    intro: "Las preguntas siguientes están relacionadas con el tiempo destinado a su trabajo y sus responsabilidades familiares.",
    preguntas: [
      { id: "g2_14", num: 14, texto: "Trabajo horas extras más de tres veces a la semana" },
      { id: "g2_15", num: 15, texto: "Mi trabajo me exige laborar en días de descanso, festivos o fines de semana" },
    ]
  },
  // Dominio: Interferencia en la relación trabajo-familia — ítems 16-17 (continúa intro de ítems 14-15)
  {
    dominio: "Interferencia en la relación trabajo-familia",
    categoria: "Organización del tiempo de trabajo",
    visualContinue: true,
    preguntas: [
      { id: "g2_16", num: 16, texto: "Considero que el tiempo en el trabajo es mucho y perjudica mis actividades familiares o personales" },
      { id: "g2_17", num: 17, texto: "Pienso en las actividades familiares o personales cuando estoy en mi trabajo" },
    ]
  },
  // ── Categoría: Factores propios de la actividad ─────────
  // Dominio: Falta de control sobre el trabajo — ítems 18-22
  {
    dominio: "Falta de control sobre el trabajo",
    categoria: "Factores propios de la actividad",
    intro: "Las preguntas siguientes están relacionadas con las decisiones que puede tomar en su trabajo.",
    preguntas: [
      { id: "g2_18", num: 18, texto: "Mi trabajo permite que desarrolle nuevas habilidades" },
      { id: "g2_19", num: 19, texto: "En mi trabajo puedo aspirar a un mejor puesto" },
      { id: "g2_20", num: 20, texto: "Durante mi jornada de trabajo puedo tomar pausas cuando las necesito" },
      { id: "g2_21", num: 21, texto: "Puedo decidir la velocidad a la que realizo mis actividades en mi trabajo" },
      { id: "g2_22", num: 22, texto: "Puedo cambiar el orden de las actividades que realizo en mi trabajo" },
    ]
  },
  // ── Categoría: Liderazgo y relaciones en el trabajo ─────
  // Dominio: Liderazgo — ítems 23-25
  {
    dominio: "Liderazgo",
    categoria: "Liderazgo y relaciones en el trabajo",
    intro: "Las preguntas siguientes están relacionadas con la capacitación e información que recibe sobre su trabajo.",
    preguntas: [
      { id: "g2_23", num: 23, texto: "Me informan con claridad cuáles son mis funciones" },
      { id: "g2_24", num: 24, texto: "Me explican claramente los resultados que debo obtener en mi trabajo" },
      { id: "g2_25", num: 25, texto: "Me informan con quién puedo resolver problemas o asuntos de trabajo" },
    ]
  },
  // Dominio: Falta de control sobre el trabajo — ítems 26-27 (continúa intro de ítems 23-25)
  {
    dominio: "Falta de control sobre el trabajo",
    categoria: "Factores propios de la actividad",
    visualContinue: true,
    preguntas: [
      { id: "g2_26", num: 26, texto: "Me permiten asistir a capacitaciones relacionadas con mi trabajo" },
      { id: "g2_27", num: 27, texto: "Recibo capacitación útil para hacer mi trabajo" },
    ]
  },
  // Dominio: Liderazgo — ítems 28-29
  {
    dominio: "Liderazgo",
    categoria: "Liderazgo y relaciones en el trabajo",
    intro: "Las preguntas siguientes se refieren a las relaciones con sus compañeros de trabajo y su jefe.",
    preguntas: [
      { id: "g2_28", num: 28, texto: "Mi jefe tiene en cuenta mis puntos de vista y opiniones" },
      { id: "g2_29", num: 29, texto: "Mi jefe ayuda a solucionar los problemas que se presentan en el trabajo" },
    ]
  },
  // Dominio: Relaciones en el trabajo — ítems 30-32 (continúa intro de ítems 28-29)
  {
    dominio: "Relaciones en el trabajo",
    categoria: "Liderazgo y relaciones en el trabajo",
    visualContinue: true,
    preguntas: [
      { id: "g2_30", num: 30, texto: "Puedo confiar en mis compañeros de trabajo" },
      { id: "g2_31", num: 31, texto: "Cuando tenemos que realizar trabajo de equipo los compañeros colaboran" },
      { id: "g2_32", num: 32, texto: "Mis compañeros de trabajo me ayudan cuando tengo dificultades" },
    ]
  },
  // Dominio: Violencia — ítems 33-40 (continúa intro de ítems 28-29)
  {
    dominio: "Violencia",
    categoria: "Liderazgo y relaciones en el trabajo",
    visualContinue: true,
    preguntas: [
      { id: "g2_33", num: 33, texto: "En mi trabajo puedo expresarme libremente sin interrupciones" },
      { id: "g2_34", num: 34, texto: "Recibo críticas constantes a mi persona y/o trabajo" },
      { id: "g2_35", num: 35, texto: "Recibo burlas, calumnias, difamaciones, humillaciones o ridiculizaciones" },
      { id: "g2_36", num: 36, texto: "Se ignora mi presencia o se me excluye de las reuniones de trabajo y en la toma de decisiones" },
      { id: "g2_37", num: 37, texto: "Se manipulan las situaciones de trabajo para hacerme parecer un mal trabajador" },
      { id: "g2_38", num: 38, texto: "Se ignoran mis éxitos laborales y se atribuyen a otros trabajadores" },
      { id: "g2_39", num: 39, texto: "Me bloquean o impiden las oportunidades que tengo para obtener ascenso o mejora en mi trabajo" },
      { id: "g2_40", num: 40, texto: "He presenciado actos de violencia en mi centro de trabajo" },
    ]
  },
  // Dominio: Carga de trabajo (condicional clientes) — ítems 41-43
  {
    dominio: "Carga de trabajo",
    categoria: "Factores propios de la actividad",
    intro: "Las preguntas siguientes están relacionadas con la atención a clientes y usuarios.",
    preguntaFiltro: { id: "g2_filtro_clientes", texto: "En mi trabajo debo brindar servicio a clientes o usuarios" },
    preguntas: [
      { id: "g2_41", num: 41, texto: "Atiendo clientes o usuarios muy enojados", condicional: true },
      { id: "g2_42", num: 42, texto: "Mi trabajo me exige atender personas muy necesitadas de ayuda o enfermas", condicional: true },
      { id: "g2_43", num: 43, texto: "Para hacer mi trabajo debo demostrar sentimientos distintos a los míos", condicional: true },
    ]
  },
  // Dominio: Relaciones en el trabajo (condicional jefe) — ítems 44-46
  {
    dominio: "Relaciones en el trabajo",
    categoria: "Liderazgo y relaciones en el trabajo",
    intro: "Las siguientes preguntas están relacionadas con las actitudes de los trabajadores que supervisa.",
    preguntaFiltro: { id: "g2_filtro_jefe", texto: "Soy jefe de otros trabajadores" },
    preguntas: [
      { id: "g2_44", num: 44, texto: "Comunican tarde los asuntos de trabajo", condicional: true },
      { id: "g2_45", num: 45, texto: "Dificultan el logro de los resultados del trabajo", condicional: true },
      { id: "g2_46", num: 46, texto: "Ignoran las sugerencias para mejorar su trabajo", condicional: true },
    ]
  },
];

export const OPCIONES_GUIA_II = [
  { valor: 0, texto: "Siempre" },
  { valor: 1, texto: "Casi siempre" },
  { valor: 2, texto: "Algunas veces" },
  { valor: 3, texto: "Casi nunca" },
  { valor: 4, texto: "Nunca" },
];

// Ítems invertidos según Tabla 2 NOM-035 (ítems positivos: Siempre=0, Nunca=4)
// Ítems 18-33: positivos, menor valor = menor riesgo
export const ITEMS_INVERTIDOS_GII = [
  "g2_18","g2_19","g2_20","g2_21","g2_22","g2_23","g2_24","g2_25","g2_26","g2_27",
  "g2_28","g2_29","g2_30","g2_31","g2_32","g2_33"
];
